import React, { PropTypes } from 'react';
import Loading from 'components/helpers/loading';
import Helmet from 'react-helmet';
import ItineraryMap from 'components/googleMap/itineraryMap';
import ItineraryDetails from './itineraryDetails';

class Itinerary extends React.Component {

    constructor(props) {
        super(props);
        var self = this,
            isLoading = false;

        if (!self.props.itinerary) {
            isLoading = true;
            self.props.getItinerary();
        }
        
        self.state = {
            isLoading: isLoading
        };
    }

    componentWillReceiveProps(nextProps) {
        var self = this;

        if (self.state.isLoading && nextProps.itinerary != null) {
            self.setState({
                isLoading: false
            });
        }
    }

    render () {
        var self = this,
            itinerary = self.props.itinerary,
            title = 'Walkabout: Itinerary';

        if (self.state.isLoading) {
            return <Loading />;
        }

        if (itinerary.title != null && itinerary.title !== '') {
            title = 'Walkabout: Itinerary for ' + itinerary.title;
        }

        return (
            <div className="map-container">
                <Helmet title={ title } />
                <ItineraryDetails itinerary={ itinerary } location={ self.props.location } />
                <ItineraryMap itinerary={ itinerary } />
            </div>
        );
    }
};

export default Itinerary;


// WEBPACK FOOTER //
// ./src/app/components/itinerary/itinerary.jsx